import React from 'react'

import Button from 'components/Form/Button'
import CompetitiveImpression from '../Impression'
import { trackEvent } from 'services/analytics'
import { competitorLogo, sourceLogo } from '../assets'
import {
  Card, CardBody, CardFooter, CardHeader, Citation, Condition, Conditions,
  Contributor, DateText, Grid, Identity, Journal, LoadMore, Logo, LogoFallback,
  MetaRow, ResultTitle, Results, ResultsCount, ResultsHeader, SourceLink,
} from './styled'

export default function ResearchList({
  formatCount, formatDate, items, loadingMore, onLoadMore, onOpen, pagination, t,
}) {
  return (
    <Results aria-live="polite">
      <ResultsHeader>
        <ResultsCount>{formatCount(pagination.total)} {t('competitive_intelligence_research_results')}</ResultsCount>
      </ResultsHeader>
      <Grid>
        {items.map((item, index) => (
          <CompetitiveImpression item={item} key={item.id} section="research">
          {impressionRef => <Card ref={impressionRef}>
            <CardHeader>
              <Identity>
                {sourceLogo(item.source) ? <Logo src={sourceLogo(item.source)} alt={item.sourceLabel} $logoKey={item.source} $source /> : <LogoFallback>{item.sourceLabel}</LogoFallback>}
              </Identity>
              <Identity end>
                {item.competitor && competitorLogo(item.competitor) ? <Logo src={competitorLogo(item.competitor)} alt={item.competitor} $logoKey={item.competitor} /> : item.competitor ? <LogoFallback>{item.competitor}</LogoFallback> : null}
                <DateText>{formatDate(item.activityDate)}</DateText>
              </Identity>
            </CardHeader>
            <CardBody>
              <ResultTitle type="button" onClick={() => onOpen(item, index)}>{item.title}</ResultTitle>
              {item.contributors ? <Contributor>{item.contributors}</Contributor> : null}
              {item.conditions?.length ? (
                <Conditions aria-label={t('competitive_intelligence_research_conditions')}>
                  {item.conditions.map(condition => <Condition key={condition}>{condition}</Condition>)}
                </Conditions>
              ) : null}
              <MetaRow>
                {item.citationCount !== null && item.citationCount !== undefined ? (
                  <Citation>{formatCount(item.citationCount)} {t('competitive_intelligence_research_citations')}</Citation>
                ) : null}
                {item.status ? <Citation>{item.status.replace(/_/g, ' ')}</Citation> : null}
              </MetaRow>
              {item.journal || item.applicant || item.deviceName ? <Journal>{item.journal || item.applicant || item.deviceName}</Journal> : null}
            </CardBody>
            <CardFooter>
              {item.externalUrl ? (
                <SourceLink href={item.externalUrl} onClick={() => trackEvent('COMPETITIVE_CONTENT_SOURCE_OPENED', {
                  competitive_section: 'research', content_type: item.recordType || 'research', content_id: item.id,
                  competitor_id: item.competitor, competitive_source: item.source, result_position: index + 1,
                })} target="_blank" rel="noopener noreferrer">
                  {t('competitive_intelligence_research_view_source')} ↗
                </SourceLink>
              ) : null}
            </CardFooter>
          </Card>}
          </CompetitiveImpression>
        ))}
      </Grid>
      {pagination.hasMore ? (
        <LoadMore>
          <Button color="blue" outline nospace loading={loadingMore} disabled={loadingMore} onClick={onLoadMore}>
            {t('competitive_intelligence_research_load_more')}
          </Button>
        </LoadMore>
      ) : null}
    </Results>
  )
}
